"use client";

import Link from "next/link";

export default function Hero() {
  return (
    <>
      <section className="hero-section hero-1 fix section-padding1">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="hero-video">
                <h1>Fun For Every Age Memories Starts Here!</h1>
                <Link href="/ticket" className="videobtn_booknow" style={{ fontFamily: "Chewy", textTransform: 'capitalize' }}>Book Now</Link>
                <video src="https://pub-5c1627b2a81f46a484ef4f77674a4729.r2.dev/uploads/latest_video_hero.mp4" autoPlay loop muted width={1920} height={550} playsInline />
              </div>
            </div>
          </div>
        </div>
      </section >
    </>
  );
}
